import React from 'react';
import ModuleRoute from 'holocron-module-route';

import ErrorLayout from './components/error/ErrorLayout';
import ErrorPage from './components/error/ErrorPage';

const childRoutes = () => [
  <ModuleRoute key="wallets-merchants" path="wallets-merchants" moduleName="amex-connect-enrollment-hub" />,
  <ModuleRoute key="connect" path="/:partner" moduleName="amex-connect-page-wrapper">
    <ModuleRoute path="select" moduleName="amex-connect-select-card" />
    <ModuleRoute path="message" moduleName="amex-connect-message" />
    <ModuleRoute path="verify" moduleName="amex-connect-verification" />
  </ModuleRoute>,
  <ModuleRoute key="error-layout" component={ErrorLayout}>
    <ModuleRoute
      code="500"
      component={ErrorPage}
      path="*/error"
      status={500}
    />
    <ModuleRoute
      code="404"
      component={ErrorPage}
      path="*"
      status={404}
    />
  </ModuleRoute>,

];

export default childRoutes;
